/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Mod_Exp_TitleInputs */

const es_faq_mod_exp_title = /** @type {(inputs: Faq_Mod_Exp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Experiencias`)
};

const gl_faq_mod_exp_title = /** @type {(inputs: Faq_Mod_Exp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Experiencias`)
};

const en_faq_mod_exp_title = /** @type {(inputs: Faq_Mod_Exp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Experiences`)
};

/**
* | output |
* | --- |
* | "Zarpar Experiences" |
*
* @param {Faq_Mod_Exp_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_mod_exp_title = /** @type {((inputs?: Faq_Mod_Exp_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Mod_Exp_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_faq_mod_exp_title(inputs)
	if (locale === "en") return en_faq_mod_exp_title(inputs)
	return es_faq_mod_exp_title(inputs)
});